import { Text, Divider, Flex, Box, Image, Headers, Heading } from '@chakra-ui/react'
import imgHome1 from '../../../assets/img/home/home2/imgHome1.jpg';
import image2 from '../../../assets/img/about_us/image2.jpg'
import { useTranslation } from 'react-i18next';
import { fontSizesByLang } from '../../../helpers/fontSizesByLang';

function WeAreTmg() {
    const { t, i18n } = useTranslation();
    const fontSizes = fontSizesByLang[i18n.language];

    return (
        <Flex direction="column" w="100%" minH="100vh" bg="#1E1D1D">

            <Flex
                direction="column"
                width="100%"
                align="center"
                justifyContent="center"
                pb="3%"
                textAlign="center"
                pt={'5%'}
            >
                <Heading
                    fontSize={fontSizes.tittlefont}

                    fontWeight="bold"
                    fontFamily="Roboto Condensed"
                    padding="2%"
                    pt="5%"
                    textAlign="center"
                >
                    <Box
                        as="span"
                        color="white"
                        display={{ base: "block", md: "inline" }}
                    >
                        {t("aboutus-tittle1")}

                    </Box>

                    <Box
                        as="span"
                        color="#AE8245"
                        display={{ base: "block", md: "inline" }}
                    >
                        {t("aboutus-tittle1.2")}
                    </Box>
                </Heading>

                <Text
                    color="#929292"
                    fontFamily="Inter"
                    fontSize={fontSizes.textfont}
                    textAlign="left"
                    px={{ base: "10%", md: '7%', lg: 0 }}
                >
                    {t("aboutus-info1")}
                </Text>
            </Flex>

            <Flex
                pt="5%"
                justifyContent="space-around"
                direction={{ base: "column", md: "row" }}
                align={{ base: "center", md: "center" }}
                textAlign={{ base: "left", md: "left" }}
                gap={{ base: 6, md: 0 }}
                pl={'5%'}
                pr={'5%'}
            >
                <Flex direction="column" width={{ base: "100%", md: "50%" }} >
                    <Heading
                        color="white"
                        fontFamily="Roboto Condensed"
                        fontSize={{ base: "3xl", md: "5xl", lg: "6xl" }}
                        p="1%"
                    >
                        {t("aboutus-tittle2")}
                    </Heading>

                    <Text color="white" fontFamily="Inter" p="1%">
                        {t("aboutus-info2")}
                    </Text>

                    <Text color="white" fontFamily="Inter" p="1%">
                        {t("aboutus-info2.2")}
                    </Text>
                </Flex>

                <Box
                    boxSize={{ base: "330px", md: "380px", lg: "450px" }}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Image
                        src={imgHome1}
                        w={{ base: "100%", md: "100%", lg: "100%" }}
                        h="80%"
                        objectFit="cover"
                        objectPosition="center"
                        borderRadius="30px"
                    />
                </Box>
            </Flex>

            <Flex
                pt="5%"
                justifyContent="space-around"
                direction={{ base: "column-reverse", md: "row" }}
                align={{ base: "center", md: "flex-start" }}
                textAlign={{ base: "left", md: "right" }}
                gap={{ base: 6, md: 0 }}
                pl={'5%'}
                pr={'5%'}
            >
                <Box
                    boxSize={{ base: "330px", md: "380px", lg: "450px" }}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Image
                        src={image2}
                        w={{ base: "100%", md: "100%", lg: "100%" }}
                        h="80%"
                        objectFit="cover"
                        objectPosition="center"
                        borderRadius="30px"
                    />
                </Box>

                <Flex direction="column" width={{ base: "100%", md: "50%" }}>
                    <Heading
                        color="#AE8245"
                        fontFamily="Roboto Condensed"
                        fontSize={{ base: "3xl", md: "5xl", lg: "6xl" }}
                        p="1%"
                    >
                        {t("aboutus-tittle3")}
                    </Heading>

                    <Text color="white" fontFamily="Inter" p="1%">
                        {t("aboutus-info3")}
                    </Text>

                    <Text color="white" fontFamily="Inter" p="1%">
                        {t("aboutus-info3.2")}
                    </Text>
                </Flex>
            </Flex>

        </Flex>

    )
}

export default WeAreTmg